import React, { useCallback, useState, memo } from 'react';
import { Select } from '@leasequery/lq.react-component-library';
import { SelectOption } from '@leasequery/lq.react-component-library/dist/models';
import { REPORT_CURRENCY_SELECT_OPTIONS } from '../../../constants';
import { ReportCurrency, ClientCustomCalendarModel } from '../../../models';
import * as Styled from './styled';
import {
  ReportTypeSetting,
  ReportSettingEndDateOption,
} from '../../../models/reportTypeSetting';
import { buildDropdownList } from './helpers/buildReportSettingData';
import { Checkbox } from '@leasequery/lq.react-component-library';
import { Icon } from '../../../components';
import { CurrencySelectorWrapper } from '../../../components';

interface ReportSettingCommitmentProps {
  onChange: (updatedValue: ReportSettingCommitmentState) => void;
  reportSettingState: ReportSettingCommitmentState;
  reportTypeSetting: ReportTypeSetting;
  isAllowPIT: boolean;
  customCalendarSettings?: ClientCustomCalendarModel;
}

export interface ReportSettingCommitmentState {
  selectedCurrency: SelectOption<ReportCurrency>;
  shortStartDate: string;
  shortEndDate: string;
  selectedRunBy: SelectOption<string>;
  selectedEndDateOption: ReportSettingEndDateOption;
  isFixedPaymentOnly: boolean;
  isValid: boolean;
}

function ReportSettingCommitment({
  onChange,
  reportSettingState,
  reportTypeSetting,
}: ReportSettingCommitmentProps): JSX.Element {
  const runByList = buildDropdownList('Commitment', 'RunBy', reportTypeSetting);
  const [isDateRangeValid, setDateRangeValidStatus] = useState(false);
  const inputHandler = useCallback(
    ({ isValid, ...rest }: ReportSettingCommitmentState) => {
      let isValidInput = isDateRangeValid;
      if (isValid !== undefined) {
        isValidInput = isValid;
        setDateRangeValidStatus(isValid);
      }

      onChange({
        ...rest,
        isValid: isValidInput,
      });
    },
    [isDateRangeValid, onChange],
  );
  return (
    <>
      <CurrencySelectorWrapper>
        <Styled.DropdownBar>
          <div>
            <Icon name="currency" />
          </div>
          <Select
            placeholder="Local currency"
            label="Currency"
            name="currency"
            options={REPORT_CURRENCY_SELECT_OPTIONS}
            onChange={useCallback(
              (option: SelectOption<ReportCurrency>): void => {
                inputHandler({
                  ...reportSettingState,
                  selectedCurrency: option,
                });
              },
              [inputHandler, reportSettingState],
            )}
            value={reportSettingState.selectedCurrency}
          />
        </Styled.DropdownBar>
      </CurrencySelectorWrapper>
      <Styled.Line />
      <Styled.DropdownBar>
        <div>
          <Icon name="gear" />
        </div>
        <div>
          <Select
            label="Run By"
            name="RunBy"
            options={runByList}
            onChange={useCallback(
              (option: SelectOption<string>): void => {
                inputHandler({ ...reportSettingState, selectedRunBy: option });
              },
              [inputHandler, reportSettingState],
            )}
            value={reportSettingState.selectedRunBy}
          />
          <p />
          <Checkbox
            name="fixedPaymentOnly"
            label="Fixed payments only"
            onChange={useCallback(
              (event): void => {
                inputHandler({
                  ...reportSettingState,
                  isFixedPaymentOnly: event.currentTarget.checked,
                });
              },
              [inputHandler, reportSettingState],
            )}
            checked={reportSettingState.isFixedPaymentOnly}
          />
        </div>
      </Styled.DropdownBar>
      <Styled.Line />
    </>
  );
}

export default memo(ReportSettingCommitment);
